import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import routes from '../../../Utils/routes';
import { useStyles } from '../styles';
import { ListItemButton, ListItemIcon, ListItemText, Box } from '@mui/material';
import { useLocation } from 'react-router-dom';

interface SideNavProps {
  handleListClick: (link: string, index: number) => void;
  name?: string;
  handleClose?: any;
}

const MobileNavTabs: React.FunctionComponent<SideNavProps> = ({ handleListClick, name, handleClose }) => {
  const classes = useStyles();
  const { pathname } = useLocation();
  const getFirstPath = pathname.split('/').filter((item: string) => item && item !== '');

  const sideNavContents = [
    {
      icon: (isActive: boolean) => <HomeOutlinedIcon className={isActive ? classes.listItemIconActive : classes.listItemIcon} />,
      label: 'Home',
      link: routes.home,
      name: 'home',
    },
    {
      icon: (isActive: boolean) => <AutoAwesomeIcon className={isActive ? classes.listItemIconActive : classes.listItemIcon} />,
      label: 'Learn',
      link: routes.learn, // Assuming a different route for Learn
      name: 'learn',
    },
  ];

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      <Box sx={{ flexGrow: 1 }}>
        {sideNavContents.map((item, index) => (
          <ListItemButton
            key={index}
            onClick={() => {
              handleListClick(item.link, index);
              if (name === 'mobile') {
                handleClose();
              }
            }}
            style={{ marginTop: index === 0 ? '15px' : '2px' }}
            className={`${classes.listItemButton} ${getFirstPath[0] === item.name && classes.listItemButtonActive}`}
          >
            <ListItemIcon sx={{ minWidth: { xs: '10px', lg: '40px' } }}>
              {item.icon(getFirstPath[0] === item.name)}
            </ListItemIcon>
            <ListItemText className={`${classes.listItemText} ${getFirstPath[0] === item.name && classes.listItemTextActive}`} sx={{ ml: 2 }}>
              {item.label}
            </ListItemText>
          </ListItemButton>
        ))}
      </Box>

      {/* Logout button at the bottom */}
      <ListItemButton
        onClick={() => {
          console.log('Logout clicked'); // Replace with actual logout function
          if (name === 'mobile') {
            handleClose();
          }
        }}
        style={{ marginTop: 'auto' }}
        className={classes.listItemButton}
      >
        <ListItemIcon sx={{ minWidth: { xs: '10px', lg: '40px' } }}>
          <ExitToAppIcon className={classes.listItemIcon} />
        </ListItemIcon>
        <ListItemText className={classes.listItemText} sx={{ ml: 2 }}>
          Logout
        </ListItemText>
      </ListItemButton>
    </Box>
  );
};

export default MobileNavTabs;
